import React, { useState } from 'react'
import Modal from 'react-modal'
import { Dropdown } from '../../helpers/components/Dropdown'
import { Link } from 'react-router-dom'

Modal.setAppElement('#root')

interface Props {
  franchiseActionDropdownMenuRefs: React.MutableRefObject<any[]>
  user: any
  index: number
  franchiseId: number
}

const FranchiseActionMenu: React.FC<Props> = ({
  franchiseActionDropdownMenuRefs,
  user,
  index,
  franchiseId
}) => {
  const [userActionMenuDroppedDown, setUserActionMenuDroppedDown] = useState<boolean>(false)

  const updateClientOnbordingInfo = (user: any) => {
    setUserActionMenuDroppedDown(!userActionMenuDroppedDown)
  }

  console.log(franchiseId)
  return (
    <>
      <button
        className={`btn btn-sm btn-icon btn-active-light-primary`}
        onClick={() => updateClientOnbordingInfo(user)}
      >
        <i className='bi bi-three-dots-vertical fs-2'></i>
      </button>
      <Dropdown
        menuRef={franchiseActionDropdownMenuRefs.current[index]}
        droppedDown={userActionMenuDroppedDown}
        setDroppedDown={setUserActionMenuDroppedDown}
      >
        <div className='p-5 py-3'>
          <Link to={`/franchise/manage-agreement/${franchiseId}`}>
            <p className='link-primary hoverable' role='button'>
              <i className='bi bi-pencil-square link-primary'></i>
              <span className='px-2'>Manage Agreement</span>
            </p>
          </Link>
          <Link to={`/franchise/clients/${franchiseId}`}>
            <p className='link-success hoverable' role='button'>
              <i className='bi bi-person-check link-success'></i>
              <span className='px-2'>View Clients</span>
            </p>
          </Link>
        </div>
      </Dropdown>
    </>
  )
}

export default FranchiseActionMenu
